/**
 * Кнопка переключения светлой/тёмной темы.
 * Иконки lucide-react (Sun / Moon) + плавный переход.
 */
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../lib/theme';

export function ThemeToggle({ className = '' }: { className?: string }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === 'dark';
  return (
    <button
      onClick={toggle}
      title={isDark ? 'Светлая тема' : 'Тёмная тема'}
      className={`p-2 rounded-full text-fg-muted hover:text-fg hover:bg-surface-2 transition ${className}`}
    >
      {isDark ? <Sun size={17} /> : <Moon size={17} />}
    </button>
  );
}
